/**
 * Created by m.igrachev on 6/16/2017.
 */
const documentedProperties = [
    {
        name: "id",
        type: "String",
        defaultValue: "n/a",
        isRequired: "true",
        description: "Identification string of the action item."
    },
    {
        name: "label",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Action item's label to be displayed."
    },
    {
        name: "icon",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Action item's icon's class name."
    },
    {
        name: "rightIcon",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description:
            "If set to true puts the icon on the right. Coming from parent. Cannot be overridden."
    },
    {
        name: "onClick",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "A callback to be called on action item click. Coming from parent. Cannot be overridden."
    },
    {
        name: "marker",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If provided will put marker on the icon of the Action (if such provided)"
    },
    {
        name: "tooltipContainerClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Add classnames to the tooltip's container"
    }
];

export default documentedProperties;
